import { OrdenacaoResponseDTO, SubfiltroResponseDTO } from '@/types/common';
import { SimNao } from '@/types/enum/SimNao';

export type FindParecerReferencialPublicoRequestDTO = {
  dePesquisaTermos: string | null;
  nuProcessoOficial: string | null;
  nuAnoProcessoOficial: string | null;
  nuParecer: string | null;
  nuAnoParecer: string | null;
  dtParecerInicio: string | null;
  dtParecerFim: string | null;
  dtValidadeInicio: string | null;
  dtValidadeFim: string | null;
  flEmenta: SimNao;
  flParecer: SimNao;
  anosValidade: string[] | null;
  anosParecer: string[] | null;
  numPag: number;
  ordenacao: Ordenacoes;
};

export enum Ordenacoes {
  DATA_DESC = 'DT_PARECER_DESC',
  DATA_ASC = 'DT_PARECER_ASC',
}

export type ParecerReferencialPublicoDTO = {
  idParecerReferencial: string;
  nuProcessoOficial: string;
  nuAnoProcessoOficial: number;
  nuParecer: string;
  nuAnoParecer: number;
  dtValidade: string;
  dtParecer: string;
  deEmenta: string;
  highlightedDesc: string;
};

export interface ParecerReferencialPublicoResponseDTO {
  ordenacoes: OrdenacaoResponseDTO[];
  pareceres: ParecerReferencialPublicoDTO[];
  subfiltros: SubfiltroResponseDTO[];
  totalHits: number;
}
